<template lang="pug">
main.login-bg
	.login-center
		.imageContainer(:style="imageStyle")
		.login-card(v-show="projects.length < 1" style="display:flex;flex-direction:column;align-items:center;text-align:center;")
			h2.login-card__title(style="width:100%;text-align:center;margin:0 0 20px;") Let's Get Started
			a.login-card__google#googleBtn(href="/users/auth/google" style="display:inline-block;") Sign in with Google
			.message.message-block.message-error.red.white-text(v-if="errorText") {{errorText}}
		.login-card(v-show="projects.length >= 1" style="display:flex;flex-direction:column;align-items:center;text-align:center;")
			h2.login-card__title(style="width:100%;text-align:center;margin:0 0 20px;") Select Project
			select#selectProject.browser-default(v-model="projectId")
				option(v-for="project in projects" :key="project.id" :value="project.objectId") {{project.name}}
			button.login-card__select-btn#chooseProjectBtn(v-on:click="authenticateAPI") Select
</template>

<script>
// @ is an alias to /src
import {wlData} from '../assets/js/constants';
import {HTTPClient} from '../assets/js/http';
let client = new HTTPClient();

export default {
	name: 'LoginGoogleInit',
	data() {
		let imageStyle = 'background-image:url("'+wlData.loginLogo+'");'+
			'width:313px;height:100px;margin-left:auto;margin-right:auto;';
		return {
			username: '',
			password: '',
			errorText: null,
			projectId: '',
			projects: [],
			imageStyle
		};
	},
	methods: {
		async fetchProjects(event){
			try {
				event.target.disabled = true;
				let username = this.username;
				let password = this.password;
				let projects = await client.robustQuery('/users/projectsWithAuth', {username, password});
				this.projects = projects;
				event.target.disabled = false;
			} catch (error) {
				console.error(error);
				event.target.disabled = false;
				this.errorText = error.message||'Login failed';
			}
		},
		async authenticateAPI(event) {
			event.target.disabled = true;
			try {
				let username = this.username;
				let password = this.password;
				let project = this.projectId;
				if(!username || !password || !project){
					window.M.toast({html: 'Select Project'});
				}
				else {
					await this.$store.dispatch('login', {username, password, project});
					if(this.$route.query.from == "onboarding"){
						window.location.replace('/onboarding');
					} else {
						window.location.replace('/');
					}
				}
			} catch (error) {
				event.target.disabled = false;
				this.errorText = true;
				console.error(error);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
	.login-bg {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		padding-left: 0;
		background-color: #000;
		background-image: url("../../public/images/bg.png");
		background-repeat: no-repeat;
		background-size: cover;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.login-center {
		width: 100%;
		max-width: 420px;
		padding: 0 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.imageContainer {
		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;
	}
	.login-card {
		width: 100%;
		margin-top: 16px;
		padding: 32px 24px;
		border-radius: 4px;
		background-color: #0097FF;
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
	}
	.login-card__title {
		margin: 0 0 20px;
		padding: 0;
		color: #fff;
		font-size: 24px;
		font-weight: 300;
		line-height: 1.3;
		text-align: center;
		width: 100%;
	}
	.login-card__google {
		display: inline-block;
		min-width: 20px;
		background-image: url("../../public/images/google/vector/btn_google_dark_normal_ios.svg");
		background-repeat: no-repeat;
		background-size: 44px 44px;
		background-position: -2px -2px;
		background-color: #4285F4;
		color: #fff !important;
		text-transform: unset;
		text-decoration: none;
		padding: 0 10px 0 48px;
		font-size: 16px;
		line-height: 40px;
		min-height: 40px;
		font-family: 'Roboto', sans-serif;
		border-radius: 2px;
		text-align: left;
	}
	#selectProject {
		width: 100%;
		max-width: 280px;
		padding: 5px;
		border-radius: 10px;
		height: 3rem;
		margin-bottom: 16px;
		background: #fff;
		color: #005B9A;
	}
	.login-card__select-btn {
		background: #fff;
		color: #005B9A;
		border: none;
		border-radius: 2px;
		padding: 0 16px;
		height: 36px;
		line-height: 36px;
		cursor: pointer;
	}
	.message {
		margin-top: 12px;
		width: 100%;
	}
</style>
